import React, { Component } from 'react'
import Grid from "../../../Utils/Grid";
import { TableHeaderColumn } from "react-bootstrap-table";
import { standardActions } from "../../../Utils/Grid/StandardActions";
import Card from '../../../Utils/Cards/Card'
import { HeaderBtnSearch } from '../../../Utils/Header'
import { Async } from "react-select";

export default class Listar extends Component {
    componentWillMount() {
        const { listar, page } = this.props;
        listar(page);
    };


    render() {
        const { listar, onSortChange, eliminar } = this.props; //Funciones
        const { data, loader, page } = this.props; //Constantes
        return (
            <Card
                titulo="Roles"
                header={
                    <HeaderBtnSearch
                        link="role/create"
                        textBtn="Crear rol"
                        {...this.props}
                    />
                }
            >
                <Grid hover striped data={data} loading={loader} onPageChange={listar} onSortChange={onSortChange} page={page}>
                    <TableHeaderColumn
                        dataField="id"
                        dataAlign="center"
                        isKey
                        dataFormat={standardActions({ editar: "role", eliminar })}
                    />
                    <TableHeaderColumn
                        dataField="name"
                        dataSort
                    >
                        ROL
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="id"
                        dataSort
                        dataFormat={(cell, row) => {
                            let gestiones = []
                            if (row.user_management) {
                                gestiones.push('Usuarios')
                            }
                            if (row.management_shops_branches) {
                                gestiones.push(' Sucursales')
                            }
                            if (row.subscription_management) {
                                gestiones.push(' Suscripciones')
                            }
                            if (row.role_management) {
                                gestiones.push(' Roles')
                            }
                            if (row.payment_management) {
                                gestiones.push(' Pagos')
                            }
                            if (row.reports) {
                                gestiones.push(' Reportes')
                            }
                            if (row.delete_registers) {
                                gestiones.push(' Eliminar registros')
                            }
                            return gestiones.slice(0, 3)
                        }}
                    >
                        GESTIÓN
                    </TableHeaderColumn>

                </Grid>

            </Card>
        )
    }
}
